(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'node-jose', './kotlin-kotlin-stdlib.js', './kotlinx-serialization-kotlinx-serialization-json.js', './kotlinx-serialization-kotlinx-serialization-core.js', './curity-ssi-libs-core-json.js', './curity-ssi-libs-core.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('node-jose'), require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./curity-ssi-libs-core-json.js'), require('./curity-ssi-libs-core.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'));
  else {
    if (typeof Jose === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'node-jose' was not found. Please, check whether 'node-jose' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-jose'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'curity-ssi-libs-jose'.");
    }
    root['curity-ssi-libs-jose'] = factory(typeof this['curity-ssi-libs-jose'] === 'undefined' ? {} : this['curity-ssi-libs-jose'], Jose, this['kotlin-kotlin-stdlib'], this['kotlinx-serialization-kotlinx-serialization-json'], this['kotlinx-serialization-kotlinx-serialization-core'], this['curity-ssi-libs-core-json'], this['curity-ssi-libs-core'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir']);
  }
}(globalThis, function (_, Jose, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.kb;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var Default_getInstance = kotlin_kotlin.$_$.p4;
  var get_lastIndex = kotlin_kotlin.$_$.ad;
  var charSequenceGet = kotlin_kotlin.$_$.w9;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
  var VOID = kotlin_kotlin.$_$.f;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var extendThrowable = kotlin_kotlin.$_$.ca;
  var captureStack = kotlin_kotlin.$_$.t9;
  var defineProp = kotlin_kotlin.$_$.aa;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var Char__rangeTo_impl_tkncvp = kotlin_kotlin.$_$.w2;
  var plus = kotlin_kotlin.$_$.u7;
  var plus_0 = kotlin_kotlin.$_$.v7;
  var numberRangeToNumber = kotlin_kotlin.$_$.gb;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
  var random = kotlin_kotlin.$_$.x7;
  var Char = kotlin_kotlin.$_$.ee;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var joinToString = kotlin_kotlin.$_$.g7;
  var toString = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.ha;
  var equals = kotlin_kotlin.$_$.ba;
  var Default_getInstance_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var isInterface = kotlin_kotlin.$_$.xa;
  var setOf = kotlin_kotlin.$_$.c8;
  var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
  var toMutableMap = kotlin_kotlin.$_$.p8;
  var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
  var toMap = kotlin_kotlin.$_$.m8;
  var emptyMap = kotlin_kotlin.$_$.s6;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var toJson = kotlin_io_curity_ssi_core_json.$_$.c1;
  var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
  var union = kotlin_kotlin.$_$.u8;
  var Collection = kotlin_kotlin.$_$.j5;
  var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
  var get = kotlin_io_curity_ssi_core_json.$_$.q;
  var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
  var toJson_0 = kotlin_io_curity_ssi_core_json.$_$.s;
  var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
  var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var toString_0 = kotlin_kotlin.$_$.vf;
  var unwrapString = kotlin_io_curity_ssi_core_json.$_$.p1;
  var unwrapOptionalJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.h1;
  var unwrapOptionalStringList = kotlin_io_curity_ssi_core_json.$_$.l1;
  var toSet = kotlin_kotlin.$_$.r8;
  var toJson_1 = kotlin_io_curity_ssi_core_json.$_$.z;
  var unwrapOptionalMultiValueString = kotlin_io_curity_ssi_core_json.$_$.j1;
  var unwrapOptionalLong = kotlin_io_curity_ssi_core_json.$_$.i1;
  var unwrapJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.e1;
  var toJson_2 = kotlin_io_curity_ssi_core_json.$_$.a1;
  var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
  var ensureNotNull = kotlin_kotlin.$_$.kf;
  var lazy = kotlin_kotlin.$_$.qf;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var initMetadataForLambda = kotlin_kotlin.$_$.na;
  var JsToJsonConverter_instance = kotlin_io_curity_ssi_core_json.$_$.c;
  var KProperty1 = kotlin_kotlin.$_$.ac;
  var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
  var isByteArray = kotlin_kotlin.$_$.ra;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var to = kotlin_kotlin.$_$.wf;
  var mapOf = kotlin_kotlin.$_$.r7;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var toSet_0 = kotlin_kotlin.$_$.s8;
  var contains = kotlin_kotlin.$_$.b6;
  var json = kotlin_kotlin.$_$.eb;
  var split = kotlin_kotlin.$_$.gd;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(JWK, 'JWK');
  initMetadataForCompanion(Companion);
  initMetadataForClass(CryptoException, 'CryptoException', VOID, Error);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(SigningKeyPair, 'SigningKeyPair');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(JsonJwk, 'JsonJwk', JsonJwk, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonJwkSerializer_getInstance});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonJwks, 'JsonJwks', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Jws, 'Jws', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(JsonJwsHeader, 'JsonJwsHeader', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonJwsHeaderSerializer_getInstance});
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(JsonJwtClaimsSet, 'JsonJwtClaimsSet', JsonJwtClaimsSet, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonJwtClaimsSetSerializer_getInstance});
  initMetadataForObject(JsonJwsHeaderSerializer, 'JsonJwsHeaderSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonJwtClaimsSetSerializer, 'JsonJwtClaimsSetSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonJwkSerializer, 'JsonJwkSerializer', VOID, JsonSerializer);
  initMetadataForInterface(JsSigningKey, 'JsSigningKey');
  initMetadataForInterface(JsVerificationKey, 'JsVerificationKey');
  initMetadataForClass(JsSigningKeyPair, 'JsSigningKeyPair');
  initMetadataForInterface(JsKeyStore, 'JsKeyStore');
  initMetadataForClass(JsJwsHeaderAndPayload, 'JsJwsHeaderAndPayload');
  initMetadataForLambda(JsDefaultKeyStore$getSigningKeyPairById$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsDefaultKeyStore$importSigningKeySpec$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsDefaultKeyStore, 'JsDefaultKeyStore', JsDefaultKeyStore, VOID, [JsKeyStore]);
  initMetadataForLambda(createSigningKeyFromJwk$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createVerificationKeyFromJwk$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createJws$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(verifyJws$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(createHashFunction$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_6);
  initMetadataForCoroutine($importSigningKeyPairCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(NodeJoseKeyStore, 'NodeJoseKeyStore', VOID, VOID, VOID, [2, 1]);
  initMetadataForCoroutine($createJsSigningKeyCOROUTINE$2, CoroutineImpl);
  initMetadataForCompanion(Companion_7, VOID, VOID, [1]);
  initMetadataForCoroutine($createJsVerificationKeyCOROUTINE$3, CoroutineImpl);
  initMetadataForCompanion(Companion_8, VOID, VOID, [1]);
  initMetadataForInterface(VerificationKey, 'VerificationKey');
  initMetadataForCoroutine($fromJwksCOROUTINE$4, CoroutineImpl);
  initMetadataForCompanion(Companion_9, VOID, VOID, [1]);
  initMetadataForCoroutine($verifyJwsCOROUTINE$5, CoroutineImpl);
  initMetadataForCoroutine($verifyJwsCOROUTINE$6, CoroutineImpl);
  initMetadataForObject(JwsUtil, 'JwsUtil', VOID, VOID, VOID, [3, 2]);
  initMetadataForClass(NativeSigningKey, 'NativeSigningKey', VOID, VOID, [JsSigningKey]);
  initMetadataForClass(NativeVerificationKey, 'NativeVerificationKey', VOID, VOID, [VerificationKey, JsVerificationKey]);
  initMetadataForClass(DefaultVerificationKeySet, 'DefaultVerificationKeySet');
  //endregion
  function JWK(jsonString) {
    this.o28_1 = jsonString;
  }
  protoOf(JWK).toString = function () {
    return 'JWK(jsonString=' + this.o28_1 + ')';
  };
  protoOf(JWK).hashCode = function () {
    return getStringHashCode(this.o28_1);
  };
  protoOf(JWK).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JWK))
      return false;
    var tmp0_other_with_cast = other instanceof JWK ? other : THROW_CCE();
    if (!(this.o28_1 === tmp0_other_with_cast.o28_1))
      return false;
    return true;
  };
  function encodeBase64url(bytes) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.text.dropLastWhile' call
      var this_0 = Default_getInstance().og_1.rg(bytes);
      var inductionVariable = get_lastIndex(this_0);
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          // Inline function 'io.curity.ssi.crypto.encodeBase64url.<anonymous>' call
          if (!(charSequenceGet(this_0, index) === _Char___init__impl__6a9atx(61))) {
            // Inline function 'kotlin.text.substring' call
            var endIndex = index + 1 | 0;
            // Inline function 'kotlin.js.asDynamic' call
            tmp$ret$3 = this_0.substring(0, endIndex);
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$3 = '';
    }
    return tmp$ret$3;
  }
  function decodeBase64Url(string) {
    return Default_getInstance().og_1.vg(string);
  }
  function Companion() {
  }
  protoOf(Companion).p28 = function (msg) {
    return new CryptoException("JWK does not contain a signing key ('" + (msg == null ? 'no extra information' : msg) + "')");
  };
  protoOf(Companion).q28 = function (msg, $super) {
    msg = msg === VOID ? null : msg;
    return $super === VOID ? this.p28(msg) : $super.p28.call(this, msg);
  };
  protoOf(Companion).r28 = function (msg) {
    return new CryptoException("JWK does not contain a verification key ('" + (msg == null ? 'no extra information' : msg) + "')");
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function CryptoException(msg, cause) {
    cause = cause === VOID ? null : cause;
    extendThrowable(this, msg, cause);
    captureStack(this, CryptoException);
    this.s28_1 = msg;
  }
  protoOf(CryptoException).l9 = function () {
    return this.s28_1;
  };
  function sha256() {
    var tmp0_elvis_lhs = createHashFunction('sha-256');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('sha-256 not supported');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function Companion_0() {
  }
  protoOf(Companion_0).t28 = function (length) {
    var allowedChars = plus_0(plus(Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90)), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122))), Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57)));
    // Inline function 'kotlin.collections.map' call
    var this_0 = numberRangeToNumber(1, length);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.crypto.Companion.uniqueAlphanumericId.<anonymous>' call
      // Inline function 'kotlin.collections.random' call
      var tmp$ret$0 = random(allowedChars, Default_getInstance_0()).o1_1;
      var tmp$ret$1 = new Char(tmp$ret$0);
      destination.e(tmp$ret$1);
    }
    return joinToString(destination, '');
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function SigningKeyPair(signingKey, verificationKey, id) {
    this.u28_1 = signingKey;
    this.v28_1 = verificationKey;
    this.w28_1 = id;
  }
  protoOf(SigningKeyPair).toString = function () {
    return 'SigningKeyPair(signingKey=' + toString(this.u28_1) + ', verificationKey=' + toString(this.v28_1) + ', id=' + this.w28_1 + ')';
  };
  protoOf(SigningKeyPair).hashCode = function () {
    var result = hashCode(this.u28_1);
    result = imul(result, 31) + hashCode(this.v28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w28_1) | 0;
    return result;
  };
  protoOf(SigningKeyPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SigningKeyPair))
      return false;
    var tmp0_other_with_cast = other instanceof SigningKeyPair ? other : THROW_CCE();
    if (!equals(this.u28_1, tmp0_other_with_cast.u28_1))
      return false;
    if (!equals(this.v28_1, tmp0_other_with_cast.v28_1))
      return false;
    if (!(this.w28_1 === tmp0_other_with_cast.w28_1))
      return false;
    return true;
  };
  function fromJwkDictionary(_this__u8e3s4, jwk, $completion) {
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance_1();
    var value = new JsonObject(jwk.xl());
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonObject), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    return _this__u8e3s4.x28(tmp$ret$2, $completion);
  }
  function Companion_1() {
    Companion_instance_1 = this;
    this.y28_1 = setOf(['use', 'alg']);
  }
  protoOf(Companion_1).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'Jwk'));
    return new JsonJwk(unwrapOptionalString(map, 'kid'), toMap(map));
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function JsonJwk(kid, customClaims) {
    Companion_getInstance_1();
    kid = kid === VOID ? null : kid;
    customClaims = customClaims === VOID ? emptyMap() : customClaims;
    this.z28_1 = kid;
    this.a29_1 = customClaims;
  }
  protoOf(JsonJwk).y26 = function () {
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.jose.JsonJwk.toJsonDictionary.<anonymous>' call
    this_0.o2(this.a29_1);
    var tmp0_safe_receiver = this.z28_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this_0.m2('kid', toJson(tmp0_safe_receiver));
    }
    var tmp$ret$3 = this_0.r8();
    return new JsonDictionary(tmp$ret$3);
  };
  protoOf(JsonJwk).b29 = function (other) {
    var allKeys = union(this.a29_1.f2(), other.a29_1.f2());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(allKeys, Collection)) {
        tmp = allKeys.s();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = allKeys.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'io.curity.ssi.jose.JsonJwk.matches.<anonymous>' call
        var thisValue = this.a29_1.e2(element);
        var otherValue = other.a29_1.e2(element);
        var tmp_0;
        if ((thisValue == null || otherValue == null) && Companion_getInstance_1().y28_1.a2(element)) {
          tmp_0 = true;
        } else {
          tmp_0 = equals(thisValue, otherValue);
        }
        if (!tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(JsonJwk).toString = function () {
    return 'JsonJwk(kid=' + this.z28_1 + ', customClaims=' + toString(this.a29_1) + ')';
  };
  protoOf(JsonJwk).hashCode = function () {
    var result = this.z28_1 == null ? 0 : getStringHashCode(this.z28_1);
    result = imul(result, 31) + hashCode(this.a29_1) | 0;
    return result;
  };
  protoOf(JsonJwk).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonJwk))
      return false;
    var tmp0_other_with_cast = other instanceof JsonJwk ? other : THROW_CCE();
    if (!(this.z28_1 == tmp0_other_with_cast.z28_1))
      return false;
    if (!equals(this.a29_1, tmp0_other_with_cast.a29_1))
      return false;
    return true;
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c29_1 = [new ArrayListSerializer(JsonJwkSerializer_getInstance())];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.jose.JsonJwks', this, 1);
    tmp0_serialDesc.wy('keys', false);
    this.d29_1 = tmp0_serialDesc;
  }
  protoOf($serializer).e29 = function (encoder, value) {
    var tmp0_desc = this.d29_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().c29_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.f29_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.e29(encoder, value instanceof JsonJwks ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.d29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_2().c29_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return JsonJwks_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).yn = function () {
    return this.d29_1;
  };
  protoOf($serializer).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_2().c29_1[0]];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function JsonJwks_init_$Init$(seen0, keys, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance().d29_1);
    }
    $this.f29_1 = keys;
    return $this;
  }
  function JsonJwks_init_$Create$(seen0, keys, serializationConstructorMarker) {
    return JsonJwks_init_$Init$(seen0, keys, serializationConstructorMarker, objectCreate(protoOf(JsonJwks)));
  }
  function JsonJwks() {
  }
  protoOf(JsonJwks).g29 = function (id) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.f29_1.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'io.curity.ssi.jose.JsonJwks.getKeyWithKid.<anonymous>' call
        if (element.z28_1 === id) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  };
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.ssi.jose.JsonJwt.Jws', this, 4);
    tmp0_serialDesc.wy('header', true);
    tmp0_serialDesc.wy('payload', false);
    tmp0_serialDesc.wy('unprotectedHeader', true);
    tmp0_serialDesc.wy('signature', true);
    this.h29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).i29 = function (encoder, value) {
    var tmp0_desc = this.h29_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.j29_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), value.j29_1);
    }
    tmp1_output.bt(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), value.k29_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.l29_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), value.l29_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.m29_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.m29_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.i29(encoder, value instanceof Jws ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.h29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, JsonJwsHeaderSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, JsonJwtClaimsSetSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, JsonJwsHeaderSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return Jws_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.h29_1;
  };
  protoOf($serializer_0).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(JsonJwsHeaderSerializer_getInstance()), JsonJwtClaimsSetSerializer_getInstance(), get_nullable(JsonJwsHeaderSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function Jws_init_$Init$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_0().h29_1);
    }
    if (0 === (seen0 & 1))
      $this.j29_1 = null;
    else
      $this.j29_1 = header;
    $this.k29_1 = payload;
    if (0 === (seen0 & 4))
      $this.l29_1 = null;
    else
      $this.l29_1 = unprotectedHeader;
    if (0 === (seen0 & 8))
      $this.m29_1 = null;
    else
      $this.m29_1 = signature;
    return $this;
  }
  function Jws_init_$Create$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker) {
    return Jws_init_$Init$(seen0, header, payload, unprotectedHeader, signature, serializationConstructorMarker, objectCreate(protoOf(Jws)));
  }
  function Jws(header, payload, unprotectedHeader, signature) {
    header = header === VOID ? null : header;
    unprotectedHeader = unprotectedHeader === VOID ? null : unprotectedHeader;
    signature = signature === VOID ? null : signature;
    this.j29_1 = header;
    this.k29_1 = payload;
    this.l29_1 = unprotectedHeader;
    this.m29_1 = signature;
  }
  protoOf(Jws).toString = function () {
    return 'Jws(header=' + toString_0(this.j29_1) + ', payload=' + this.k29_1.toString() + ', unprotectedHeader=' + toString_0(this.l29_1) + ', signature=' + this.m29_1 + ')';
  };
  protoOf(Jws).hashCode = function () {
    var result = this.j29_1 == null ? 0 : this.j29_1.hashCode();
    result = imul(result, 31) + this.k29_1.hashCode() | 0;
    result = imul(result, 31) + (this.l29_1 == null ? 0 : this.l29_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m29_1 == null ? 0 : getStringHashCode(this.m29_1)) | 0;
    return result;
  };
  protoOf(Jws).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Jws))
      return false;
    var tmp0_other_with_cast = other instanceof Jws ? other : THROW_CCE();
    if (!equals(this.j29_1, tmp0_other_with_cast.j29_1))
      return false;
    if (!this.k29_1.equals(tmp0_other_with_cast.k29_1))
      return false;
    if (!equals(this.l29_1, tmp0_other_with_cast.l29_1))
      return false;
    if (!(this.m29_1 == tmp0_other_with_cast.m29_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  protoOf(Companion_4).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JwsHeader'));
    var tmp2_typ = unwrapOptionalString(map, 'typ');
    var tmp3_cty = unwrapOptionalString(map, 'cty');
    var tmp4_alg = unwrapString(map, 'alg');
    var tmp5_jku = unwrapOptionalString(map, 'jku');
    var tmp6_jwk = unwrapOptionalJsonDictionary(map, 'jwk');
    var tmp7_kid = unwrapOptionalString(map, 'kid');
    var tmp8_x5u = unwrapOptionalString(map, 'x5u');
    var tmp9_x5c = unwrapOptionalString(map, 'x5c');
    var tmp10_x5t = unwrapOptionalString(map, 'x5t');
    var tmp11_x5tS256 = unwrapOptionalString(map, 'x5t#s256');
    var tmp1_safe_receiver = unwrapOptionalStringList(map, 'crit');
    var tmp12_crit = tmp1_safe_receiver == null ? null : toSet(tmp1_safe_receiver);
    var tmp13_customClaims = toMap(map);
    return new JsonJwsHeader(tmp4_alg, tmp2_typ, tmp3_cty, tmp5_jku, tmp6_jwk, tmp7_kid, tmp8_x5u, tmp9_x5c, tmp10_x5t, tmp11_x5tS256, tmp12_crit, tmp13_customClaims);
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function JsonJwsHeader(alg, typ, cty, jku, jwk, kid, x5u, x5c, x5t, x5tS256, crit, customClaims) {
    typ = typ === VOID ? null : typ;
    cty = cty === VOID ? null : cty;
    jku = jku === VOID ? null : jku;
    jwk = jwk === VOID ? null : jwk;
    kid = kid === VOID ? null : kid;
    x5u = x5u === VOID ? null : x5u;
    x5c = x5c === VOID ? null : x5c;
    x5t = x5t === VOID ? null : x5t;
    x5tS256 = x5tS256 === VOID ? null : x5tS256;
    crit = crit === VOID ? null : crit;
    customClaims = customClaims === VOID ? emptyMap() : customClaims;
    this.n29_1 = alg;
    this.o29_1 = typ;
    this.p29_1 = cty;
    this.q29_1 = jku;
    this.r29_1 = jwk;
    this.s29_1 = kid;
    this.t29_1 = x5u;
    this.u29_1 = x5c;
    this.v29_1 = x5t;
    this.w29_1 = x5tS256;
    this.x29_1 = crit;
    this.y29_1 = customClaims;
  }
  protoOf(JsonJwsHeader).y26 = function () {
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>' call
    this_0.o2(this.y29_1);
    var tmp14_safe_receiver = this.o29_1;
    if (tmp14_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('typ', toJson(tmp14_safe_receiver));
    }
    var tmp15_safe_receiver = this.p29_1;
    if (tmp15_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('cty', toJson(tmp15_safe_receiver));
    }
    this_0.m2('alg', toJson(this.n29_1));
    var tmp16_safe_receiver = this.q29_1;
    if (tmp16_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('jku', toJson(tmp16_safe_receiver));
    }
    var tmp17_safe_receiver = this.r29_1;
    if (tmp17_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('jwk', tmp17_safe_receiver.a27());
    }
    var tmp18_safe_receiver = this.s29_1;
    if (tmp18_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('kid', toJson(tmp18_safe_receiver));
    }
    var tmp19_safe_receiver = this.t29_1;
    if (tmp19_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('x5u', toJson(tmp19_safe_receiver));
    }
    var tmp20_safe_receiver = this.v29_1;
    if (tmp20_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('x5t', toJson(tmp20_safe_receiver));
    }
    var tmp21_safe_receiver = this.w29_1;
    if (tmp21_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwsHeader.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('x5t#s256', toJson(tmp21_safe_receiver));
    }
    var tmp22_safe_receiver = this.x29_1;
    if (tmp22_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this_0.m2('crit', toJson_1(tmp22_safe_receiver));
    }
    var tmp$ret$19 = this_0.r8();
    return new JsonDictionary(tmp$ret$19);
  };
  protoOf(JsonJwsHeader).toString = function () {
    return 'JsonJwsHeader(alg=' + this.n29_1 + ', typ=' + this.o29_1 + ', cty=' + this.p29_1 + ', jku=' + this.q29_1 + ', jwk=' + toString_0(this.r29_1) + ', kid=' + this.s29_1 + ', x5u=' + this.t29_1 + ', x5c=' + this.u29_1 + ', x5t=' + this.v29_1 + ', x5tS256=' + this.w29_1 + ', crit=' + toString_0(this.x29_1) + ', customClaims=' + toString(this.y29_1) + ')';
  };
  protoOf(JsonJwsHeader).hashCode = function () {
    var result = getStringHashCode(this.n29_1);
    result = imul(result, 31) + (this.o29_1 == null ? 0 : getStringHashCode(this.o29_1)) | 0;
    result = imul(result, 31) + (this.p29_1 == null ? 0 : getStringHashCode(this.p29_1)) | 0;
    result = imul(result, 31) + (this.q29_1 == null ? 0 : getStringHashCode(this.q29_1)) | 0;
    result = imul(result, 31) + (this.r29_1 == null ? 0 : hashCode(this.r29_1)) | 0;
    result = imul(result, 31) + (this.s29_1 == null ? 0 : getStringHashCode(this.s29_1)) | 0;
    result = imul(result, 31) + (this.t29_1 == null ? 0 : getStringHashCode(this.t29_1)) | 0;
    result = imul(result, 31) + (this.u29_1 == null ? 0 : getStringHashCode(this.u29_1)) | 0;
    result = imul(result, 31) + (this.v29_1 == null ? 0 : getStringHashCode(this.v29_1)) | 0;
    result = imul(result, 31) + (this.w29_1 == null ? 0 : getStringHashCode(this.w29_1)) | 0;
    result = imul(result, 31) + (this.x29_1 == null ? 0 : hashCode(this.x29_1)) | 0;
    result = imul(result, 31) + hashCode(this.y29_1) | 0;
    return result;
  };
  protoOf(JsonJwsHeader).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonJwsHeader))
      return false;
    var tmp0_other_with_cast = other instanceof JsonJwsHeader ? other : THROW_CCE();
    if (!(this.n29_1 === tmp0_other_with_cast.n29_1))
      return false;
    if (!(this.o29_1 == tmp0_other_with_cast.o29_1))
      return false;
    if (!(this.p29_1 == tmp0_other_with_cast.p29_1))
      return false;
    if (!(this.q29_1 == tmp0_other_with_cast.q29_1))
      return false;
    if (!equals(this.r29_1, tmp0_other_with_cast.r29_1))
      return false;
    if (!(this.s29_1 == tmp0_other_with_cast.s29_1))
      return false;
    if (!(this.t29_1 == tmp0_other_with_cast.t29_1))
      return false;
    if (!(this.u29_1 == tmp0_other_with_cast.u29_1))
      return false;
    if (!(this.v29_1 == tmp0_other_with_cast.v29_1))
      return false;
    if (!(this.w29_1 == tmp0_other_with_cast.w29_1))
      return false;
    if (!equals(this.x29_1, tmp0_other_with_cast.x29_1))
      return false;
    if (!equals(this.y29_1, tmp0_other_with_cast.y29_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  protoOf(Companion_5).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JwsHeader'));
    return new JsonJwtClaimsSet(unwrapOptionalString(map, 'iss'), unwrapOptionalString(map, 'sub'), unwrapOptionalMultiValueString(map, 'aud'), unwrapOptionalLong(map, 'exp'), unwrapOptionalLong(map, 'nbf'), unwrapOptionalLong(map, 'iat'), unwrapOptionalString(map, 'jti'), unwrapJsonDictionary(map, 'cnf'), toMap(map));
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function JsonJwtClaimsSet$toJsonDictionary$lambda(item) {
    return toJson(item);
  }
  function JsonJwtClaimsSet(iss, sub, aud, exp, nbf, iat, jti, cnf, customClaims) {
    iss = iss === VOID ? null : iss;
    sub = sub === VOID ? null : sub;
    aud = aud === VOID ? null : aud;
    exp = exp === VOID ? null : exp;
    nbf = nbf === VOID ? null : nbf;
    iat = iat === VOID ? null : iat;
    jti = jti === VOID ? null : jti;
    cnf = cnf === VOID ? null : cnf;
    customClaims = customClaims === VOID ? emptyMap() : customClaims;
    this.z29_1 = iss;
    this.a2a_1 = sub;
    this.b2a_1 = aud;
    this.c2a_1 = exp;
    this.d2a_1 = nbf;
    this.e2a_1 = iat;
    this.f2a_1 = jti;
    this.g2a_1 = cnf;
    this.h2a_1 = customClaims;
  }
  protoOf(JsonJwtClaimsSet).y26 = function () {
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>' call
    this_0.o2(this.h2a_1);
    var tmp23_safe_receiver = this.z29_1;
    if (tmp23_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('iss', toJson(tmp23_safe_receiver));
    }
    var tmp24_safe_receiver = this.a2a_1;
    if (tmp24_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('sub', toJson(tmp24_safe_receiver));
    }
    var tmp25_safe_receiver = this.b2a_1;
    if (tmp25_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('aud', tmp25_safe_receiver.l27(JsonJwtClaimsSet$toJsonDictionary$lambda));
    }
    var tmp26_safe_receiver = this.c2a_1;
    if (tmp26_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('exp', toJson_2(tmp26_safe_receiver));
    }
    var tmp27_safe_receiver = this.d2a_1;
    if (tmp27_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('nbf', toJson_2(tmp27_safe_receiver));
    }
    var tmp28_safe_receiver = this.e2a_1;
    if (tmp28_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('iat', toJson_2(tmp28_safe_receiver));
    }
    var tmp29_safe_receiver = this.f2a_1;
    if (tmp29_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.jose.JsonJwtClaimsSet.toJsonDictionary.<anonymous>.<anonymous>' call
      this_0.m2('jti', toJson(tmp29_safe_receiver));
    }
    var tmp30_safe_receiver = this.g2a_1;
    if (tmp30_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this_0.m2('cnf', tmp30_safe_receiver.a27());
    }
    var tmp$ret$17 = this_0.r8();
    return new JsonDictionary(tmp$ret$17);
  };
  protoOf(JsonJwtClaimsSet).toString = function () {
    return 'JsonJwtClaimsSet(iss=' + this.z29_1 + ', sub=' + this.a2a_1 + ', aud=' + toString_0(this.b2a_1) + ', exp=' + toString_0(this.c2a_1) + ', nbf=' + toString_0(this.d2a_1) + ', iat=' + toString_0(this.e2a_1) + ', jti=' + this.f2a_1 + ', cnf=' + toString_0(this.g2a_1) + ', customClaims=' + toString(this.h2a_1) + ')';
  };
  protoOf(JsonJwtClaimsSet).hashCode = function () {
    var result = this.z29_1 == null ? 0 : getStringHashCode(this.z29_1);
    result = imul(result, 31) + (this.a2a_1 == null ? 0 : getStringHashCode(this.a2a_1)) | 0;
    result = imul(result, 31) + (this.b2a_1 == null ? 0 : this.b2a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.c2a_1 == null ? 0 : this.c2a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d2a_1 == null ? 0 : this.d2a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.e2a_1 == null ? 0 : this.e2a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f2a_1 == null ? 0 : getStringHashCode(this.f2a_1)) | 0;
    result = imul(result, 31) + (this.g2a_1 == null ? 0 : hashCode(this.g2a_1)) | 0;
    result = imul(result, 31) + hashCode(this.h2a_1) | 0;
    return result;
  };
  protoOf(JsonJwtClaimsSet).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonJwtClaimsSet))
      return false;
    var tmp0_other_with_cast = other instanceof JsonJwtClaimsSet ? other : THROW_CCE();
    if (!(this.z29_1 == tmp0_other_with_cast.z29_1))
      return false;
    if (!(this.a2a_1 == tmp0_other_with_cast.a2a_1))
      return false;
    if (!equals(this.b2a_1, tmp0_other_with_cast.b2a_1))
      return false;
    if (!equals(this.c2a_1, tmp0_other_with_cast.c2a_1))
      return false;
    if (!equals(this.d2a_1, tmp0_other_with_cast.d2a_1))
      return false;
    if (!equals(this.e2a_1, tmp0_other_with_cast.e2a_1))
      return false;
    if (!(this.f2a_1 == tmp0_other_with_cast.f2a_1))
      return false;
    if (!equals(this.g2a_1, tmp0_other_with_cast.g2a_1))
      return false;
    if (!equals(this.h2a_1, tmp0_other_with_cast.h2a_1))
      return false;
    return true;
  };
  function JsonJwsHeaderSerializer() {
    JsonJwsHeaderSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_4);
  }
  var JsonJwsHeaderSerializer_instance;
  function JsonJwsHeaderSerializer_getInstance() {
    if (JsonJwsHeaderSerializer_instance == null)
      new JsonJwsHeaderSerializer();
    return JsonJwsHeaderSerializer_instance;
  }
  function JsonJwtClaimsSetSerializer() {
    JsonJwtClaimsSetSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_5);
  }
  var JsonJwtClaimsSetSerializer_instance;
  function JsonJwtClaimsSetSerializer_getInstance() {
    if (JsonJwtClaimsSetSerializer_instance == null)
      new JsonJwtClaimsSetSerializer();
    return JsonJwtClaimsSetSerializer_instance;
  }
  function JsonJwkSerializer() {
    JsonJwkSerializer_instance = this;
    JsonSerializer.call(this, Companion_getInstance_1());
  }
  var JsonJwkSerializer_instance;
  function JsonJwkSerializer_getInstance() {
    if (JsonJwkSerializer_instance == null)
      new JsonJwkSerializer();
    return JsonJwkSerializer_instance;
  }
  function JsSigningKey() {
  }
  function JsVerificationKey() {
  }
  function JsSigningKeyPair(signingKey, verificationKey, id) {
    this.signingKey = signingKey;
    this.verificationKey = verificationKey;
    this.id = id;
  }
  protoOf(JsSigningKeyPair).i2a = function () {
    return this.signingKey;
  };
  protoOf(JsSigningKeyPair).j2a = function () {
    return this.verificationKey;
  };
  protoOf(JsSigningKeyPair).k2a = function () {
    return this.id;
  };
  protoOf(JsSigningKeyPair).ba = function () {
    return this.signingKey;
  };
  protoOf(JsSigningKeyPair).ca = function () {
    return this.verificationKey;
  };
  protoOf(JsSigningKeyPair).qj = function () {
    return this.id;
  };
  protoOf(JsSigningKeyPair).l2a = function (signingKey, verificationKey, id) {
    return new JsSigningKeyPair(signingKey, verificationKey, id);
  };
  protoOf(JsSigningKeyPair).copy = function (signingKey, verificationKey, id, $super) {
    signingKey = signingKey === VOID ? this.signingKey : signingKey;
    verificationKey = verificationKey === VOID ? this.verificationKey : verificationKey;
    id = id === VOID ? this.id : id;
    return this.l2a(signingKey, verificationKey, id);
  };
  protoOf(JsSigningKeyPair).toString = function () {
    return 'JsSigningKeyPair(signingKey=' + toString(this.signingKey) + ', verificationKey=' + toString(this.verificationKey) + ', id=' + this.id + ')';
  };
  protoOf(JsSigningKeyPair).hashCode = function () {
    var result = hashCode(this.signingKey);
    result = imul(result, 31) + hashCode(this.verificationKey) | 0;
    result = imul(result, 31) + getStringHashCode(this.id) | 0;
    return result;
  };
  protoOf(JsSigningKeyPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsSigningKeyPair))
      return false;
    var tmp0_other_with_cast = other instanceof JsSigningKeyPair ? other : THROW_CCE();
    if (!equals(this.signingKey, tmp0_other_with_cast.signingKey))
      return false;
    if (!equals(this.verificationKey, tmp0_other_with_cast.verificationKey))
      return false;
    if (!(this.id === tmp0_other_with_cast.id))
      return false;
    return true;
  };
  function JsKeyStore() {
  }
  function JsJwsHeaderAndPayload$header$delegate$lambda($inner) {
    return function () {
      return JsonToJsConverter_instance.n28(ensureNotNull($inner.j29_1).xl());
    };
  }
  function JsJwsHeaderAndPayload$payload$delegate$lambda($inner) {
    return function () {
      return JsonToJsConverter_instance.n28($inner.k29_1.xl());
    };
  }
  function JsJwsHeaderAndPayload(inner) {
    var tmp = this;
    tmp.m2a_1 = lazy(JsJwsHeaderAndPayload$header$delegate$lambda(inner));
    var tmp_0 = this;
    tmp_0.n2a_1 = lazy(JsJwsHeaderAndPayload$payload$delegate$lambda(inner));
  }
  protoOf(JsJwsHeaderAndPayload).o2a = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m2a_1;
    header$factory();
    return this_0.b1();
  };
  protoOf(JsJwsHeaderAndPayload).p2a = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n2a_1;
    payload$factory();
    return this_0.b1();
  };
  function createSigningKeyFromJwk(jwkString) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, createSigningKeyFromJwk$slambda_0(jwkString, null));
  }
  function createVerificationKeyFromJwk(jwkString) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, createVerificationKeyFromJwk$slambda_0(jwkString, null));
  }
  function createJws(key, header, payload) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, createJws$slambda_0(header, payload, key, null));
  }
  function unsafeParseJws(jws) {
    var result = JwsUtil_getInstance().r2a(jws);
    return new JsJwsHeaderAndPayload(result);
  }
  function verifyJws(key, jws) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, verifyJws$slambda_0(key, jws, null));
  }
  function JsDefaultKeyStore$getSigningKeyPairById$slambda(this$0, $id, resultContinuation) {
    this.a2b_1 = this$0;
    this.b2b_1 = $id;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).d2b = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).y9 = function (p1, $completion) {
    return this.d2b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.a2b_1.f2b_1.g2b(this.b2b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              var tmp_1 = tmp0_safe_receiver.u28_1;
              var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
              var tmp_3 = tmp0_safe_receiver.v28_1;
              tmp_0 = new JsSigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), tmp0_safe_receiver.w28_1);
            }

            return tmp_0;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsDefaultKeyStore$getSigningKeyPairById$slambda).e2b = function ($this$promise, completion) {
    var i = new JsDefaultKeyStore$getSigningKeyPairById$slambda(this.a2b_1, this.b2b_1, completion);
    i.c2b_1 = $this$promise;
    return i;
  };
  function JsDefaultKeyStore$getSigningKeyPairById$slambda_0(this$0, $id, resultContinuation) {
    var i = new JsDefaultKeyStore$getSigningKeyPairById$slambda(this$0, $id, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.d2b($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsDefaultKeyStore$importSigningKeySpec$slambda(this$0, $id, $jwkString, resultContinuation) {
    this.p2b_1 = this$0;
    this.q2b_1 = $id;
    this.r2b_1 = $jwkString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).t2b = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).y9 = function (p1, $completion) {
    return this.t2b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.p2b_1.f2b_1.u2b(this.q2b_1, new JWK(this.r2b_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var it = suspendResult;
            var tmp_0 = it.u28_1;
            var tmp_1 = tmp_0 instanceof NativeSigningKey ? tmp_0 : THROW_CCE();
            var tmp_2 = it.v28_1;
            return new JsSigningKeyPair(tmp_1, tmp_2 instanceof NativeVerificationKey ? tmp_2 : THROW_CCE(), it.w28_1);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsDefaultKeyStore$importSigningKeySpec$slambda).e2b = function ($this$promise, completion) {
    var i = new JsDefaultKeyStore$importSigningKeySpec$slambda(this.p2b_1, this.q2b_1, this.r2b_1, completion);
    i.s2b_1 = $this$promise;
    return i;
  };
  function JsDefaultKeyStore$importSigningKeySpec$slambda_0(this$0, $id, $jwkString, resultContinuation) {
    var i = new JsDefaultKeyStore$importSigningKeySpec$slambda(this$0, $id, $jwkString, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.t2b($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsDefaultKeyStore() {
    this.f2b_1 = Companion_instance_6.v2b();
  }
  protoOf(JsDefaultKeyStore).getSigningKeyPairById = function (id) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsDefaultKeyStore$getSigningKeyPairById$slambda_0(this, id, null));
  };
  protoOf(JsDefaultKeyStore).importSigningKeySpec = function (id, jwkString) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsDefaultKeyStore$importSigningKeySpec$slambda_0(this, id, jwkString, null));
  };
  function createSigningKeyFromJwk$slambda($jwkString, resultContinuation) {
    this.e2c_1 = $jwkString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createSigningKeyFromJwk$slambda).g2c = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(createSigningKeyFromJwk$slambda).y9 = function (p1, $completion) {
    return this.g2c((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createSigningKeyFromJwk$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = Companion_instance_7.h2c(this.e2c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(createSigningKeyFromJwk$slambda).e2b = function ($this$promise, completion) {
    var i = new createSigningKeyFromJwk$slambda(this.e2c_1, completion);
    i.f2c_1 = $this$promise;
    return i;
  };
  function createSigningKeyFromJwk$slambda_0($jwkString, resultContinuation) {
    var i = new createSigningKeyFromJwk$slambda($jwkString, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.g2c($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createVerificationKeyFromJwk$slambda($jwkString, resultContinuation) {
    this.q2c_1 = $jwkString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createVerificationKeyFromJwk$slambda).s2c = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(createVerificationKeyFromJwk$slambda).y9 = function (p1, $completion) {
    return this.s2c((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createVerificationKeyFromJwk$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = Companion_instance_8.t2c(this.q2c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(createVerificationKeyFromJwk$slambda).e2b = function ($this$promise, completion) {
    var i = new createVerificationKeyFromJwk$slambda(this.q2c_1, completion);
    i.r2c_1 = $this$promise;
    return i;
  };
  function createVerificationKeyFromJwk$slambda_0($jwkString, resultContinuation) {
    var i = new createVerificationKeyFromJwk$slambda($jwkString, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.s2c($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function createJws$slambda($header, $payload, $key, resultContinuation) {
    this.c2d_1 = $header;
    this.d2d_1 = $payload;
    this.e2d_1 = $key;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createJws$slambda).i2d = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(createJws$slambda).y9 = function (p1, $completion) {
    return this.i2d((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createJws$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.g2d_1 = JsToJsonConverter_instance.l28(this.c2d_1);
            this.h2d_1 = JsToJsonConverter_instance.l28(this.d2d_1);
            this.v8_1 = 1;
            var tmp_0 = JwsUtil_getInstance();
            var tmp_1 = this.e2d_1;
            suspendResult = tmp_0.j2d(tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE(), Companion_instance_4.d27(this.g2d_1), Companion_instance_5.d27(this.h2d_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(createJws$slambda).e2b = function ($this$promise, completion) {
    var i = new createJws$slambda(this.c2d_1, this.d2d_1, this.e2d_1, completion);
    i.f2d_1 = $this$promise;
    return i;
  };
  function createJws$slambda_0($header, $payload, $key, resultContinuation) {
    var i = new createJws$slambda($header, $payload, $key, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.i2d($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function verifyJws$slambda($key, $jws, resultContinuation) {
    this.s2d_1 = $key;
    this.t2d_1 = $jws;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(verifyJws$slambda).v2d = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(verifyJws$slambda).y9 = function (p1, $completion) {
    return this.v2d((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(verifyJws$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            var tmp_0 = JwsUtil_getInstance();
            var tmp_1 = this.s2d_1;
            suspendResult = tmp_0.w2d(isInterface(tmp_1, VerificationKey) ? tmp_1 : THROW_CCE(), this.t2d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            return new JsJwsHeaderAndPayload(result);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(verifyJws$slambda).e2b = function ($this$promise, completion) {
    var i = new verifyJws$slambda(this.s2d_1, this.t2d_1, completion);
    i.u2d_1 = $this$promise;
    return i;
  };
  function verifyJws$slambda_0($key, $jws, resultContinuation) {
    var i = new verifyJws$slambda($key, $jws, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.v2d($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function header$factory() {
    return getPropertyCallableRef('header', 1, KProperty1, function (receiver) {
      return receiver.header;
    }, null);
  }
  function payload$factory() {
    return getPropertyCallableRef('payload', 1, KProperty1, function (receiver) {
      return receiver.payload;
    }, null);
  }
  function get_ianaNamesToWebCryptoNames() {
    _init_properties_HashFunctions_kt__715y2t();
    return ianaNamesToWebCryptoNames;
  }
  var ianaNamesToWebCryptoNames;
  function createHashFunction(algorithm) {
    _init_properties_HashFunctions_kt__715y2t();
    var tmp0_elvis_lhs = get_ianaNamesToWebCryptoNames().e2(algorithm);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var webCryptoName = tmp;
    return createHashFunction$slambda_0(webCryptoName, null);
  }
  function createHashFunction$slambda($webCryptoName, resultContinuation) {
    this.f2e_1 = $webCryptoName;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(createHashFunction$slambda).i2e = function (input, $completion) {
    var tmp = this.j2e(input, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(createHashFunction$slambda).y9 = function (p1, $completion) {
    return this.i2e((!(p1 == null) ? isByteArray(p1) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(createHashFunction$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            tmp_0.h2e_1 = this.g2e_1;
            this.v8_1 = 1;
            suspendResult = await_0(get_portableCrypto().subtle.digest(this.f2e_1, this.h2e_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var arrayBuffer = suspendResult;
            return new Int8Array(arrayBuffer);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(createHashFunction$slambda).j2e = function (input, completion) {
    var i = new createHashFunction$slambda(this.f2e_1, completion);
    i.g2e_1 = input;
    return i;
  };
  function createHashFunction$slambda_0($webCryptoName, resultContinuation) {
    var i = new createHashFunction$slambda($webCryptoName, resultContinuation);
    var l = function (input, $completion) {
      return i.i2e(input, $completion);
    };
    l.$arity = 1;
    return l;
  }
  var properties_initialized_HashFunctions_kt_isn33x;
  function _init_properties_HashFunctions_kt__715y2t() {
    if (!properties_initialized_HashFunctions_kt_isn33x) {
      properties_initialized_HashFunctions_kt_isn33x = true;
      ianaNamesToWebCryptoNames = mapOf([to('sha-256', 'SHA-256'), to('sha-384', 'SHA-384'), to('sha-384', 'SHA-512')]);
    }
  }
  function Companion_6() {
  }
  protoOf(Companion_6).v2b = function () {
    return new NodeJoseKeyStore(Jose.JWK.createKeyStore());
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $importSigningKeyPairCOROUTINE$1(_this__u8e3s4, id, spec, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s2e_1 = _this__u8e3s4;
    this.t2e_1 = id;
    this.u2e_1 = spec;
  }
  protoOf($importSigningKeyPairCOROUTINE$1).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.v2e_1 = this.u2e_1;
            var tmp_0 = this.v2e_1;
            if (tmp_0 instanceof JWK) {
              this.v8_1 = 1;
              var it = JSON.parse(this.u2e_1.o28_1);
              it['kid'] = this.t2e_1;
              suspendResult = await_0(this.s2e_1.x2e_1.add(JSON.stringify(it)), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              noWhenBranchMatchedException();
            }

            break;
          case 1:
            this.w2e_1 = suspendResult;
            this.v8_1 = 2;
            continue $sm;
          case 2:
            var nativeKey = this.w2e_1;
            return new SigningKeyPair(new NativeSigningKey(nativeKey), new NativeVerificationKey(nativeKey), this.t2e_1);
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function NodeJoseKeyStore(keyStore) {
    this.x2e_1 = keyStore;
  }
  protoOf(NodeJoseKeyStore).g2b = function (id, $completion) {
    var tmp2_safe_receiver = this.x2e_1.get(id);
    var tmp;
    if (tmp2_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return new SigningKeyPair(new NativeSigningKey(tmp2_safe_receiver), new NativeVerificationKey(tmp2_safe_receiver), id);
    }
    return tmp;
  };
  protoOf(NodeJoseKeyStore).u2b = function (id, spec, $completion) {
    var tmp = new $importSigningKeyPairCOROUTINE$1(this, id, spec, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function get_portableCrypto() {
    _init_properties_PortableCrypto_kt__13g90k();
    return portableCrypto;
  }
  var portableCrypto;
  var properties_initialized_PortableCrypto_kt_ubyltq;
  function _init_properties_PortableCrypto_kt__13g90k() {
    if (!properties_initialized_PortableCrypto_kt_ubyltq) {
      properties_initialized_PortableCrypto_kt_ubyltq = true;
      // Inline function 'kotlin.js.unsafeCast' call
      portableCrypto = globalThis.crypto;
    }
  }
  function secureRandom(len) {
    var bytes = new Int8Array(len);
    get_portableCrypto().getRandomValues(bytes);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return bytes;
  }
  function $createJsSigningKeyCOROUTINE$2(_this__u8e3s4, jwkString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g2f_1 = _this__u8e3s4;
    this.h2f_1 = jwkString;
  }
  protoOf($createJsSigningKeyCOROUTINE$2).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = await_0(Jose.JWK.asKey(this.h2f_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var key = suspendResult;
            if (JSON.stringify(key.toJSON()) === JSON.stringify(key.toJSON(true))) {
              throw Companion_instance.q28();
            }

            this.i2f_1 = new NativeSigningKey(key);
            this.w8_1 = 3;
            this.v8_1 = 4;
            continue $sm;
          case 2:
            this.w8_1 = 3;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof Error) {
              var ex = this.y8_1;
              var tmp_1 = this;
              throw Companion_instance.p28(ex.message);
            } else {
              throw this.y8_1;
            }

          case 3:
            throw this.y8_1;
          case 4:
            this.w8_1 = 3;
            return this.i2f_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_7() {
  }
  protoOf(Companion_7).h2c = function (jwkString, $completion) {
    var tmp = new $createJsSigningKeyCOROUTINE$2(this, jwkString, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $createJsVerificationKeyCOROUTINE$3(_this__u8e3s4, jwkString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r2f_1 = _this__u8e3s4;
    this.s2f_1 = jwkString;
  }
  protoOf($createJsVerificationKeyCOROUTINE$3).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = await_0(Jose.JWK.asKey(this.s2f_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var key = suspendResult;
            this.t2f_1 = new NativeVerificationKey(key);
            this.w8_1 = 3;
            this.v8_1 = 4;
            continue $sm;
          case 2:
            this.w8_1 = 3;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof Error) {
              var ex = this.y8_1;
              var tmp_1 = this;
              throw Companion_instance.r28(ex.message);
            } else {
              throw this.y8_1;
            }

          case 3:
            throw this.y8_1;
          case 4:
            this.w8_1 = 3;
            return this.t2f_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_8() {
  }
  protoOf(Companion_8).x28 = function (jwkString, $completion) {
    return this.t2c(jwkString, $completion);
  };
  protoOf(Companion_8).t2c = function (jwkString, $completion) {
    var tmp = new $createJsVerificationKeyCOROUTINE$3(this, jwkString, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function VerificationKey() {
  }
  function $fromJwksCOROUTINE$4(_this__u8e3s4, jwksString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d2g_1 = _this__u8e3s4;
    this.e2g_1 = jwksString;
  }
  protoOf($fromJwksCOROUTINE$4).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = await_0(Jose.JWK.asKeyStore(this.e2g_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = new NodeJoseKeyStore(ARGUMENT);
            return new DefaultVerificationKeySet(ARGUMENT_0);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function Companion_9() {
  }
  protoOf(Companion_9).f2g = function (jwksString, $completion) {
    var tmp = new $fromJwksCOROUTINE$4(this, jwksString, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function $verifyJwsCOROUTINE$5(_this__u8e3s4, key, jws, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o2g_1 = _this__u8e3s4;
    this.p2g_1 = key;
    this.q2g_1 = jws;
  }
  protoOf($verifyJwsCOROUTINE$5).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            var tmp_1 = this.p2g_1;
            tmp_0.r2g_1 = (tmp_1 instanceof NativeVerificationKey ? tmp_1 : THROW_CCE()).u2g_1;
            var tmp_2 = this;
            tmp_2.s2g_1 = 'Error verifying JWS';
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = await_0(Jose.JWS.createVerify(this.r2g_1).verify(this.q2g_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.t2g_1 = suspendResult;
            this.w8_1 = 4;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.w8_1 = 4;
            var tmp_3 = this.y8_1;
            if (tmp_3 instanceof Error) {
              var ex = this.y8_1;
              var tmp_4 = this;
              throw new CryptoException(this.s2g_1 + ' (' + ex.message + ')', ex);
            } else {
              throw this.y8_1;
            }

          case 3:
            this.w8_1 = 4;
            var result = this.t2g_1;
            var tmp_5 = JsToJsonConverter_instance.k28(result.header);
            var header = tmp_5 instanceof JsonObject ? tmp_5 : THROW_CCE();
            var protectedHeaders = toSet_0(result.protected);
            if (!equals(header.f2(), protectedHeaders)) {
              throw new CryptoException("Header properties don't match protected header properties");
            }

            var msg = 'Payload must be a JSON object';
            var tmp_6;
            try {
              var this_0 = Default_getInstance_1();
              var string = JwsUtil_getInstance().q2a_1.decode(result.payload);
              var this_1 = this_0.dp();
              var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
              tmp_6 = this_0.cp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            } catch ($p) {
              var tmp_7;
              if ($p instanceof Error) {
                var ex_0 = $p;
                throw new CryptoException(msg + ' (' + ex_0.message + ')', ex_0);
              } else {
                throw $p;
              }
            }

            var payload = tmp_6;
            if (!equals(result.key, this.r2g_1)) {
              throw new CryptoException('Key mismatch');
            }

            return new Jws(Companion_instance_4.d27(header), payload);
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $verifyJwsCOROUTINE$6(_this__u8e3s4, keySet, jws, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.e2h_1 = _this__u8e3s4;
    this.f2h_1 = keySet;
    this.g2h_1 = jws;
  }
  protoOf($verifyJwsCOROUTINE$6).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.h2h_1 = this.f2h_1.k2h().x2e_1;
            var tmp_0 = this;
            tmp_0.i2h_1 = 'Error verifying JWS';
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = await_0(Jose.JWS.createVerify(this.h2h_1).verify(this.g2h_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.j2h_1 = suspendResult;
            this.w8_1 = 4;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.w8_1 = 4;
            var tmp_1 = this.y8_1;
            if (tmp_1 instanceof Error) {
              var ex = this.y8_1;
              var tmp_2 = this;
              throw new CryptoException(this.i2h_1 + ' (' + ex.message + ')', ex);
            } else {
              throw this.y8_1;
            }

          case 3:
            this.w8_1 = 4;
            var result = this.j2h_1;
            var tmp_3 = JsToJsonConverter_instance.k28(result.header);
            var header = tmp_3 instanceof JsonObject ? tmp_3 : THROW_CCE();
            var protectedHeaders = toSet_0(result.protected);
            if (!equals(header.f2(), protectedHeaders)) {
              throw new CryptoException("Header properties don't match protected header properties");
            }

            var msg = 'Payload must be a JSON object';
            var tmp_4;
            try {
              var this_0 = Default_getInstance_1();
              var string = JwsUtil_getInstance().q2a_1.decode(result.payload);
              var this_1 = this_0.dp();
              var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
              tmp_4 = this_0.cp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), string);
            } catch ($p) {
              var tmp_5;
              if ($p instanceof Error) {
                var ex_0 = $p;
                throw new CryptoException(msg + ' (' + ex_0.message + ')', ex_0);
              } else {
                throw $p;
              }
            }

            var payload = tmp_4;
            if (!contains(this.h2h_1.all(), result.key)) {
              throw new CryptoException('Key mismatch');
            }

            return new Jws(Companion_instance_4.d27(header), payload);
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function JwsUtil() {
    JwsUtil_instance = this;
    this.q2a_1 = new TextDecoder();
  }
  protoOf(JwsUtil).j2d = function (key, header, payload, $completion) {
    var privateKey = (key instanceof NativeSigningKey ? key : THROW_CCE()).key;
    var opt = json([to('compact', true), to('fields', JsonToJsConverter_instance.n28(header.xl()))]);
    var keyOpt = json([to('key', privateKey), to('reference', false)]);
    var tmp = Jose.JWS.createSign(opt, keyOpt);
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance_1();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, payload);
    return await_0(tmp.update(tmp$ret$2).final(), $completion);
  };
  protoOf(JwsUtil).r2a = function (jws) {
    var parts = split(jws, ['.']);
    if (!(parts.m() === 3)) {
      throw new CryptoException('JWS must have three parts, however has ' + parts.m() + ' parts');
    }
    // Inline function 'io.curity.ssi.crypto.tryAndMapToCryptoException' call
    var msg = 'First part must be a JSON object';
    var tmp;
    try {
      // Inline function 'io.curity.ssi.jose.JwsUtil.unsafeParseJws.<anonymous>' call
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = Default_getInstance_1();
      var string = JwsUtil_getInstance().q2a_1.decode(Jose.util.base64url.decode(parts.o(0)));
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.dp();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(JsonJwsHeader), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.cp(tmp$ret$1, string);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var ex = $p;
        throw new CryptoException(msg + ' (' + ex.message + ')', ex);
      } else {
        throw $p;
      }
    }
    var header = tmp;
    // Inline function 'io.curity.ssi.crypto.tryAndMapToCryptoException' call
    var msg_0 = 'Second part must be a JSON object';
    var tmp_1;
    try {
      // Inline function 'io.curity.ssi.jose.JwsUtil.unsafeParseJws.<anonymous>' call
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_3 = Default_getInstance_1();
      var string_0 = JwsUtil_getInstance().q2a_1.decode(Jose.util.base64url.decode(parts.o(1)));
      // Inline function 'kotlinx.serialization.serializer' call
      var this_4 = this_3.dp();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_5 = serializer(this_4, createKType(getKClass(JsonJwtClaimsSet), arrayOf([]), false));
      var tmp$ret$6 = isInterface(this_5, KSerializer) ? this_5 : THROW_CCE();
      tmp_1 = this_3.cp(tmp$ret$6, string_0);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var ex_0 = $p;
        throw new CryptoException(msg_0 + ' (' + ex_0.message + ')', ex_0);
      } else {
        throw $p;
      }
    }
    var payload = tmp_1;
    return new Jws(header, payload);
  };
  protoOf(JwsUtil).w2d = function (key, jws, $completion) {
    var tmp = new $verifyJwsCOROUTINE$5(this, key, jws, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JwsUtil).l2h = function (keySet, jws, $completion) {
    var tmp = new $verifyJwsCOROUTINE$6(this, keySet, jws, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  var JwsUtil_instance;
  function JwsUtil_getInstance() {
    if (JwsUtil_instance == null)
      new JwsUtil();
    return JwsUtil_instance;
  }
  function NativeSigningKey(key) {
    this.key = key;
  }
  protoOf(NativeSigningKey).a1 = function () {
    return this.key;
  };
  protoOf(NativeSigningKey).ba = function () {
    return this.key;
  };
  protoOf(NativeSigningKey).m2h = function (key) {
    return new NativeSigningKey(key);
  };
  protoOf(NativeSigningKey).copy = function (key, $super) {
    key = key === VOID ? this.key : key;
    return this.m2h(key);
  };
  protoOf(NativeSigningKey).toString = function () {
    return 'NativeSigningKey(key=' + toString(this.key) + ')';
  };
  protoOf(NativeSigningKey).hashCode = function () {
    return hashCode(this.key);
  };
  protoOf(NativeSigningKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeSigningKey))
      return false;
    var tmp0_other_with_cast = other instanceof NativeSigningKey ? other : THROW_CCE();
    if (!equals(this.key, tmp0_other_with_cast.key))
      return false;
    return true;
  };
  function NativeVerificationKey$jwk$delegate$lambda(this$0) {
    return function () {
      var jsonElement = JsToJsonConverter_instance.k28(this$0.u2g_1.toJSON());
      var tmp;
      if (jsonElement instanceof JsonObject) {
        tmp = Companion_getInstance_1().d27(jsonElement);
      } else {
        throw Exception_init_$Create$('Unexpected JWT format');
      }
      return tmp;
    };
  }
  function NativeVerificationKey(key) {
    this.u2g_1 = key;
    var tmp = this;
    tmp.v2g_1 = lazy(NativeVerificationKey$jwk$delegate$lambda(this));
  }
  protoOf(NativeVerificationKey).u2f = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v2g_1;
    jwk$factory();
    return this_0.b1();
  };
  protoOf(NativeVerificationKey).toString = function () {
    return 'NativeVerificationKey(key=' + toString(this.u2g_1) + ')';
  };
  protoOf(NativeVerificationKey).hashCode = function () {
    return hashCode(this.u2g_1);
  };
  protoOf(NativeVerificationKey).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeVerificationKey))
      return false;
    var tmp0_other_with_cast = other instanceof NativeVerificationKey ? other : THROW_CCE();
    if (!equals(this.u2g_1, tmp0_other_with_cast.u2g_1))
      return false;
    return true;
  };
  function jwk$factory() {
    return getPropertyCallableRef('jwk', 1, KProperty1, function (receiver) {
      return receiver.u2f();
    }, null);
  }
  function DefaultVerificationKeySet(keyStore) {
    this.n2h_1 = keyStore;
  }
  protoOf(DefaultVerificationKeySet).k2h = function () {
    return this.n2h_1;
  };
  protoOf(DefaultVerificationKeySet).toString = function () {
    return 'DefaultVerificationKeySet(keyStore=' + toString(this.n2h_1) + ')';
  };
  protoOf(DefaultVerificationKeySet).hashCode = function () {
    return hashCode(this.n2h_1);
  };
  protoOf(DefaultVerificationKeySet).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultVerificationKeySet))
      return false;
    var tmp0_other_with_cast = other instanceof DefaultVerificationKeySet ? other : THROW_CCE();
    if (!equals(this.n2h_1, tmp0_other_with_cast.n2h_1))
      return false;
    return true;
  };
  //region block: post-declaration
  defineProp(protoOf(CryptoException), 'message', function () {
    return this.l9();
  });
  protoOf(JsonJwk).f2 = get_keys;
  protoOf(JsonJwk).vl = get;
  protoOf(JsonJwk).xl = toMap_0;
  protoOf(JsonJwk).a27 = toJson_0;
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  protoOf(JsonJwsHeader).f2 = get_keys;
  protoOf(JsonJwsHeader).vl = get;
  protoOf(JsonJwsHeader).xl = toMap_0;
  protoOf(JsonJwsHeader).a27 = toJson_0;
  protoOf(JsonJwtClaimsSet).f2 = get_keys;
  protoOf(JsonJwtClaimsSet).vl = get;
  protoOf(JsonJwtClaimsSet).xl = toMap_0;
  protoOf(JsonJwtClaimsSet).a27 = toJson_0;
  defineProp(protoOf(JsJwsHeaderAndPayload), 'header', protoOf(JsJwsHeaderAndPayload).o2a);
  defineProp(protoOf(JsJwsHeaderAndPayload), 'payload', protoOf(JsJwsHeaderAndPayload).p2a);
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.JsSigningKeyPair = JsSigningKeyPair;
    _.JsJwsHeaderAndPayload = JsJwsHeaderAndPayload;
    _.createSigningKeyFromJwk = createSigningKeyFromJwk;
    _.createVerificationKeyFromJwk = createVerificationKeyFromJwk;
    _.createJws = createJws;
    _.unsafeParseJws = unsafeParseJws;
    _.verifyJws = verifyJws;
    var $io = _.io || (_.io = {});
    var $io$curity = $io.curity || ($io.curity = {});
    var $io$curity$ssi = $io$curity.ssi || ($io$curity.ssi = {});
    var $io$curity$ssi$jose = $io$curity$ssi.jose || ($io$curity$ssi.jose = {});
    $io$curity$ssi$jose.NativeSigningKey = NativeSigningKey;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = JsDefaultKeyStore;
  _.$_$.b = JsJwsHeaderAndPayload;
  _.$_$.c = fromJwkDictionary;
  _.$_$.d = Companion_instance_0;
  _.$_$.e = Companion_instance_8;
  _.$_$.f = Companion_instance_9;
  _.$_$.g = Companion_getInstance_1;
  _.$_$.h = $serializer_getInstance;
  _.$_$.i = $serializer_getInstance_0;
  _.$_$.j = JwsUtil_getInstance;
  _.$_$.k = CryptoException;
  _.$_$.l = SigningKeyPair;
  _.$_$.m = createHashFunction;
  _.$_$.n = decodeBase64Url;
  _.$_$.o = encodeBase64url;
  _.$_$.p = secureRandom;
  _.$_$.q = sha256;
  _.$_$.r = JsonJwk;
  _.$_$.s = JsonJwsHeader;
  _.$_$.t = Jws;
  _.$_$.u = JsonJwtClaimsSet;
  _.$_$.v = NativeSigningKey;
  _.$_$.w = NativeVerificationKey;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-jose.js.map
